import React from 'react';
import { vars } from '../../theme';
import { HBBannerProps, TBannerActionTheme } from '../HBBanner/HBBanner.types';
import HBBannerBase from '../HBBanner/HBBannerBase';
import { MustIncludeOneOfBasicTestIdProps } from '../common/internal/test-id.types';
import type { buttonThemes } from '../HBButton/HBButton.styles';

export interface Props
    extends Omit<HBBannerProps, 'hideIcon' | 'whiteBanner'> {}

const ACTION_THEME_TO_BUTTON_THEME: Record<
    TBannerActionTheme,
    keyof typeof buttonThemes
> = {
    primary: 'primary',
    secondary: 'secondary-solid-secondary',
    'button-link': 'button-link-solid'
};

const PlaceholderBanner = ({
    actionsTheme = 'primary',
    ...props
}: Props & MustIncludeOneOfBasicTestIdProps) => {
    return (
        <HBBannerBase
            {...props}
            accentLine={vars.colors.stroke.primary}
            background={vars.colors.surface.neutral}
            primaryActionTheme={ACTION_THEME_TO_BUTTON_THEME[actionsTheme]}
        />
    );
};

export default PlaceholderBanner;
